import styled from 'styled-components';
import { Button } from '@bufferapp/ui';

export const ButtonStyled = styled(Button)`
  margin-left: 8px;
`;
